module.exports = __webpack_public_path__ + "static/media/bed.062cd518.png";